module.exports = __webpack_public_path__ + "static/media/19a.5df316f0.jpg";